// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
// 主函数中引入路由配置
import router from './router'
//主函数中引入elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/base.css';
//引入国际语言样式+ElementUI
import i18n from './i18n/langs';
// global css
import './assets/styles/index.less';
import './assets/font/iconfont.css';
import axios from 'axios';
import store from './store'
//使用elementUI,VueRouter
Vue.use(ElementUI);
Vue.use(VueRouter);
// 按需引入然后注册在vue原型上
import { Message} from 'element-ui';
Vue.prototype.$message = Message;
//引入echarts
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
//使用axios
Vue.prototype.axios=axios;
axios.defaults.baseURL = process.env.VUE_APP_API_URL
Vue.config.productionTip=false;

//路由跳转之前调用
router.beforeEach((to,from,next)=>{
 // console.log("打印这个路劲："+to.path);
 // let isLogin=sessionStorage.getItem('isLogin');
  
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title ='古杉数据'+' | ' +to.meta.title;
  }
  if(to.path === '/'){
    next({path:'/index'});
  }
 // else if(to.path === '/login'){
   //  window.location.href='http://localhost:9092/#/login';
    //    window.open("http://localhost:9092/#/login","_blank")
    // return;
 // }
  next();
})
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App),
  mounted () {//新增
    document.dispatchEvent(new Event('render-event'))
  }
})

